import React from 'react';
import { Switch, Route, withRouter } from 'react-router-dom';
import { HotelCollectionList } from 'containers/HotelCollection/List';
import { HotelCollectionDetail } from 'containers/HotelCollection/Detail';
import { compose } from 'redux';
import { RouteComponentProps } from 'react-router';

export interface HotelCollectionRoutingProps extends RouteComponentProps {}

export const HotelCollectionRoutingComponent = (_props: HotelCollectionRoutingProps) => {
  return (
    <Switch>
      <Route exact path={`/hotels-collection`} component={HotelCollectionList} />
      <Route path={`/hotels-collection/:hotelUuid`} component={HotelCollectionDetail} />
    </Switch>
  );
};

export const HotelCollectionRouting = compose(withRouter)(HotelCollectionRoutingComponent);
